// extracted by mini-css-extract-plugin
module.exports = {"base":"SystemNotifications_base__318RB","cell":"SystemNotifications_cell__36NhK"};